import { Pipe, PipeTransform } from "@angular/core";
import { formatNumberToHuman } from "./number-to-human";

@Pipe({ name: "numberToHuman" })
export class NumberToHumanPipe implements PipeTransform {
  public transform(n: number) {
    return formatNumberToHuman(n);
  }
}
